
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/bestsellers",
      function () {
        return require("private-next-pages/products/bestsellers/index.tsx");
      }
    ]);
  